// extracted by mini-css-extract-plugin
export var copyrightContainer = "Footer-module--copyrightContainer--lDH8a";
export var divider = "Footer-module--divider--ubf6+";
export var footer = "Footer-module--footer--rLNBC";
export var moscaLink = "Footer-module--moscaLink--pou2F";
export var span = "Footer-module--span--gbXSd";